import { ApplicationSettingsContext } from '../providers/ApplicationSettingsProvider';
import { useContext } from 'react';

export default function useApplicationSettings() {
  const { appSettings, loading } = useContext(ApplicationSettingsContext);

  return { appSettings, loading };
}
